export default function distance(a, b) {
  return Math.abs(a - b);
}
